export const ZOOMS = {
  6: { scale: 1.5, repeat: '17px', buildingScale: 0.105 },
  7: { scale: 1.6, repeat: '17px', buildingScale: 0.115 },
  8: { scale: 1.7, repeat: '17px', buildingScale: 0.125 },
  9: { scale: 1.8, repeat: '15px', buildingScale: 0.14 },
  10: { scale: 1.9, repeat: '16px', buildingScale: 0.16 },
  11: { scale: 2, repeat: '17px', buildingScale: 0.18 },
  12: { scale: 2.2, repeat: '18px', buildingScale: 0.21 },
  13: { scale: 2.4, repeat: '20px', buildingScale: 0.24 },
  14: { scale: 2.6, repeat: '22px', buildingScale: 0.28 },
  15: { scale: 2.8, repeat: '21px', buildingScale: 0.3 },
  16: { scale: 3, repeat: '23px', buildingScale: 0.38 },
  17: { scale: 3.2, repeat: '25px', buildingScale: 0.46 },
  18: { scale: 3.4, repeat: '27px', buildingScale: 0.57 },
  19: { scale: 3.6, repeat: '29px', buildingScale: 0.75 },
  20: { scale: 3.6, repeat: '31px', buildingScale: 0.85 },
  21: { scale: 3.6, repeat: '33px', buildingScale: 1 },
  22: { scale: 3.6, repeat: '35px', buildingScale: 1.15 },
  23: { scale: 3.6, repeat: '37px', buildingScale: 1.35 },
};

export const COUNTRY_BUILDING_SCALE_MULTIPLAYER = 4;
